import React from 'react';

import { theme } from 'antd';

const { useToken } = theme;

const LogoutIcon = ({ color, ...rest }: { color?: string; className?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="SignOut">
        <path
          id="Vector"
          d="M8.75 3.125H3.75V16.875H8.75"
          stroke={color ?? token.colorText}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M8.75 10H17.5"
          stroke={color ?? token.colorText}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M14.375 6.875L17.5 10L14.375 13.125"
          stroke={color ?? token.colorText}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default LogoutIcon;
